import './contacto.css'

const InfoContacto = (props) => {
  return props.contacto.map((c) => (
    <div key={c.id}>
      <div className="col-12 col-md-6 col-lg-4 mt-3">
        <ul className="contacto-list">
          <li>
            <div className="item-contacto">
              <i className="fa fa-phone f-blue f-size-20" aria-hidden="true"></i>
              Teléfono
            </div>
            <ul className="sub-lista">
              <li>{c.telefono}</li>
            </ul>
          </li>
          <li>
            <div className="item-contacto">
              <i className="fa fa-envelope-o f-blue f-size-20" aria-hidden="true"></i>
              E-mail Soporte
            </div>
            <ul className="sub-lista">
              <li>{c.emailSoporte}</li>
            </ul>
          </li>
          <li>
            <div className="item-contacto">
              <i className="fa fa-envelope-o f-blue f-size-20" aria-hidden="true"></i>
              E-mail cobranzas
            </div>
            <ul className="sub-lista">
              <li>{c.emailCobranzas}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  ))
}

export default InfoContacto
